<template>
  <div class="columns is-marginless is-paddingless">
    <div class="column is-5 has-background-white is-paddingless is-secondary-content">
      <div class="hero is-secondary-content">
        <div class="is-relative is-height-100p">
          <div class="pa-20 is-concurrent is-overflow-y-active">
            <div class="hero-head mb-2">
              <b-field>
                <template slot="label">
                  <qd-label :label="$t('concurrent.pointCentral')" />
                </template>
                <AutoCompleteAdresse
                  @place_change="changeAdresse"
                  :libelle="libelleAdresse"/>
              </b-field>

              <b-slider class="py-10"
                v-model="rayon"
                :min="constantes.rayonMin"
                :max="constantes.rayonMax"
                :step="constantes.rayonStep"
                :custom-formatter="(val) => val + 'km'"
                @change="sliderChange"
                tooltip/>

              <b-field class="pb-10">
                <template slot="label">
                  <qd-label :label="$t('concurrent.searchConcurrent')" />
                </template>
                <b-input id="input-searchBox" placeholder="recherche"></b-input>
              </b-field>
            </div>
            <div class="p-0 is-relative">
              <div class="is-overflow">
                <div class="level" v-if="concurrentsFilter.length">
                  <div class="level-left has-text-weight-bold is-size-14px has-text-gird-1">
                    {{ $t('concurrent.nbreConcurrentSelectionne', {nbre: concurrentSelected}) }}
                  </div>
                  <div class="level-right">
                    <b-button :type="allSelected ? 'is-primary' : ''" @click="selectAll">
                      <b-icon :icon="allSelected
                        ? 'checkbox-multiple-marked-outline'
                        : 'checkbox-multiple-blank-outline'">
                      </b-icon>
                      <span class="is-size-14px">
                        {{ !allSelected
                          ? $t('concurrent.toutSelectionner')
                          : $t('concurrent.toutDeselectionner')}}
                      </span>
                    </b-button>
                  </div>
                </div>
                <div class="media"
                  v-for="(concurrent, index) in concurrentsFilter"
                  :key="index">
                  <div class="media-left">
                    <figure>
                      <img :src="getImg(concurrent.urlLogo)" class="img-cover">
                    </figure>
                  </div>
                  <div class="media-content">
                    <div class="content">
                      <div class="level mb-0">
                        <div class="level-left">
                          <div class="level-item">
                            <img class="image is-16x16" :src="concurrent.icon">
                          </div>
                          <div class="level-item">
                            <strong>{{ concurrent.name }}</strong>
                          </div>
                        </div>
                        <div class="level-right">
                          <b-checkbox v-model="concurrent.selected"></b-checkbox>
                        </div>
                      </div>
                      <p> {{ concurrent.adresse }} </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="is-footer-child-content has-background-white">
            <div>
              <div class="level mx-20 mb-10 mt-10">
              <div class="level-left"></div>
              <div class="level-right">
                <div class="level-item">
                  <b-button type="is-white" @click="annuler">
                    <p class="is-size-14px has-text-weight-bold">
                      {{$t('concurrent.btnRetour')}}
                    </p>
                  </b-button>
                </div>
                <div class="level-item">
                  <b-button
                    :disabled="concurrentSelected === 0"
                    type="is-primary"
                    @click="parametrerConcurrent">
                    <p class="is-size-14px has-text-weight-bold">
                      {{$t('concurrent.btnParametrer')}}
                    </p>
                  </b-button>
                </div>
              </div>
            </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="column is-paddingless">
      <div class="hero is-secondary-content is-relative">
        <div class="map">
          <gmap-Map
            class="googleMap"
            :center="constantes.centerDefault"
            :zoom="constantes.zoomDefault"
            :options="{ mapTypeControlOptions: constantes.mapType }"
            @tilesloaded="initCarte"
            ref="carto">

            <!-- Marker point de vente -->
            <gmap-marker
              v-if="afficherMarkerPdv && markerPointDeVente"
              :position="markerPointDeVente.coordonnees"
              :icon="markerPointDeVente.icon">
            </gmap-marker>

            <!-- Marker point central-->
            <gmap-marker
              v-if="!afficherMarkerPdv"
              :position="adressePointCentral.coordonnees"
              :icon="constantes.markerPointNoir">
            </gmap-marker>

            <gmap-Marker
              v-for="(concurrent, index) in concurrentsFilter.length ? concurrentsFilter : []"
              :key="index"
              :position="concurrent.position"
              :animation="concurrent.animation"
              :icon="genererIconConcurrent(concurrent)">
            </gmap-Marker>
          </gmap-Map>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import QdLabel from '@/components/general/qdLabel.vue';
import AutoCompleteAdresse from '@/components/general/autoCompleteAdresse.vue';
import * as types from '@/store/creationRecommandation/pointDeVente-mutation-type';
import * as Config from '@/configuration/configurationCarte';
import { getIconPdvData,
 iconColorGetter, TAILLE_ICON_GRAND } from '@/services/gestionIcon/iconColorGetter';
import { getImg } from '@/services/general/general';
import { placeToConcurrent } from '@/services/concurrent/concurrent';
import filtreConcurrent from '@/services/concurrent/concurrentsFilter';
import { getCoordonneesByAdresse } from '@/services/general/genererAdresse';

const PointDeVente = createNamespacedHelpers('pointDeVente');
const Recommandation = createNamespacedHelpers('recommandations');

export default {
  components: {
    QdLabel,
    AutoCompleteAdresse,
  },
  data() {
    return {
      constantes: {
        rayonMin: Config.RAYON_MIN,
        rayonMax: Config.RAYON_MAX,
        rayonStep: Config.RAYON_STEP,
        centerDefault: Config.CENTER_DEFAULT,
        zoomDefault: Config.ZOOM_DEFAULT,
        markerPointNoir: Config.MARKER_POINT_NOIR,
        mapType: Config.MAP_TYPE_CONTROL_OPTIONS,
      },
      map: null,
      concurrents: [],
      markerPointDeVente: {},
      mountedLoad: false,
      selectAllValue: false,
    };
  },
  watch: {
    adressePointCentral() {
      this.levelZoom();
    },
  },
  computed: {
    ...PointDeVente.mapGetters({
      getRayon: 'rayon',
      getAfficherMarkerPdv: 'afficherMarkerPdv',
      getAdressePointCentral: 'adressePointCentral',
      concurrentSelectionnes: 'concurrentSelectionnes',
    }),
    ...Recommandation.mapGetters({
      pointDeVenteRecommandation: 'pointDeVente',
    }),
    libelleAdresse() {
      if (this.adressePointCentral === null) return '';
      return this.adressePointCentral.intitule1 || this.adressePointCentral.adresse1;
    },
    rayon: {
      get() {
        return this.getRayon;
      },
      set(value) {
        this.setFilterRayon(value);
      },
    },
    adressePointCentral: {
      get() {
        return this.getAdressePointCentral;
      },
      set(value) {
        this.setAdressePointCentral(value);
      },
    },
    afficherMarkerPdv: {
      get() {
        return this.getAfficherMarkerPdv;
      },
      set(value) {
        this.setAfficherMarkerPdv(value);
      },
    },
    concurrentsFilter() {
      if (this.adressePointCentral === null) return [];
      const coordonnees = getCoordonneesByAdresse(this.adressePointCentral);
      return filtreConcurrent(this.rayon, coordonnees, this.concurrents);
    },
    concurrentSelected() {
      return (this.concurrentsFilter.filter(el => {
        return el.selected;
      })).length;
    },
    allSelected() {
      return this.concurrentsFilter.length === this.concurrentSelected;
    },
  },
  methods: {
    ...PointDeVente.mapMutations({
      setFilterRayon: types.SET_FILTER_RAYON,
      setConcurrentSelectionnes: types.SET_CONCURRENT_SELECTIONNES,
      setAdressePointCentral: types.SET_ADRESSE_POINT_CENTRAL,
      setAfficherMarkerPdv: types.SET_AFFICHER_MARKER_PDV,
    }),
    getImg(img) {
      return getImg(img);
    },
    async changeAdresse(e) {
      if (!e) return;
      this.adressePointCentral = e;
      const { adressePostale } = this.pointDeVenteRecommandation;
      const libellePdvRecom = adressePostale.intitule1 || adressePostale.adresse1;
      if (this.adressePointCentral.libelle !== libellePdvRecom) {
        this.afficherMarkerPdv = false;
      } else {
        this.genererMarkerPdv();
        this.afficherMarkerPdv = true;
      }
      this.levelZoom();
    },
    async initCarte() {
      const input = document.getElementById('input-searchBox');
      const searchBox = new google.maps.places.SearchBox(input);
      await this.initPoi();
      searchBox.setBounds(this.map.getBounds());
      this.map.addListener('bounds_changed', () => {
        searchBox.setBounds(this.map.getBounds());
      });
      searchBox.addListener('places_changed', async () => {
        const loadingComponent = this.$buefy.loading.open();
        this.concurrents = searchBox.getPlaces().map(place => {
          return placeToConcurrent(place, this.pointDeVenteRecommandation);
        });
        await this.fitBounds();
        loadingComponent.close();
      });
      await this.genererMarkerPdv();
      if (!this.mountedLoad) await this.fitBounds();
    },
    async fitBounds() {
      const bounds = new google.maps.LatLngBounds();
      if (this.concurrentsFilter.length) {
        this.concurrentsFilter.forEach(el => {
          bounds.extend(el.position);
        });
      }
      if (this.markerPointDeVente.coordonnees && this.afficherMarkerPdv) {
        bounds.extend(this.markerPointDeVente.coordonnees);
      }
      if (this.adressePointCentral && this.adressePointCentral.coordonnees && !this.afficherMarkerPdv) {
        bounds.extend(this.adressePointCentral.coordonnees);
      }
      this.map.fitBounds(bounds);
    },
    async levelZoom() {
      if (!this.$refs.carto.$mapPromise) return;
      await this.$refs.carto.$mapPromise;
      await this.fitBounds();
    },
    annuler() {
      this.afficherMarkerPdv = true;
      this.$router.push({ name: 'liste-panneau' });
    },
    async sliderChange() {
      const loadingComponent = this.$buefy.loading.open({ container: null });
      await this.levelZoom();
      setTimeout(() => {loadingComponent.close()}, 3000);
    },
    async genererMarkerPdv() {
      const { adressePostale, srcImg } = this.pointDeVenteRecommandation;
      const coordonnees = getCoordonneesByAdresse(adressePostale);
      if (!coordonnees) return;
      this.markerPointDeVente = {
        icon: (await getIconPdvData(srcImg)).icon,
        coordonnees,
        srcImg,
      };
    },
    selectAll() {
      this.selectAllValue = !this.selectAllValue;
      this.concurrentsFilter.forEach((el) => {
        el.selected = this.selectAllValue;
      });
    },
    genererIconConcurrent(concurrent) {
      let color = Config.COULEUR_PUCE_DEFAULT;
      if (concurrent.selected) color = '#2daa4a';
      return iconColorGetter(color, TAILLE_ICON_GRAND, null, false);
    },
    parametrerConcurrent() {
      const allConcurrentsSelected = this.concurrentsFilter.filter(el => el.selected);
      this.setConcurrentSelectionnes(allConcurrentsSelected);
      this.$router.push({ name: 'parametrer-concurrent' });
    },
    async initPoi() {
      this.map = await this.$refs.carto.$mapPromise;
      const styleMap = new google.maps.StyledMapType(
        Config.STYLE_MAPS_POI_HIDDEN,
        { name:  Config.MAP_TYPE_NAME },
      );
      this.map.mapTypes.set("styled_map", styleMap);
    },
  },
  async mounted() {
    if (!this.adressePointCentral) {
      this.setAdressePointCentral(this.pointDeVenteRecommandation.adressePostale);
    }
    this.concurrents = this.concurrentSelectionnes;
    this.rayon = Config.RAYON_DEFAULT;
    this.map = await this.$refs.carto.$mapPromise;
    await this.initCarte();
    this.mountedLoad = true;
  }
};
</script>
